// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/MyriadPro-reg.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/MyriadPro-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/BaiJamjuree-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/BaiJamjuree-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fonts/BaiJamjuree-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/fonts/BaiJamjuree-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("assets/fonts/BaiJamjuree-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 400;
}

@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 700;
}

@font-face {
  font-family: "MyriadPro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 400;
}

@font-face {
  font-family: "MyriadPro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: 700;
}

@font-face {
  font-family: "Bai Jamjuree";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-weight: 300;
}

@font-face {
  font-family: "Bai Jamjuree";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-weight: 400;
}

@font-face {
  font-family: "Bai Jamjuree";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-weight: 500;
}

@font-face {
  font-family: "Bai Jamjuree";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

@font-face {
  font-family: "Bai Jamjuree";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-weight: 700;
}

body {
  margin: 0;
  font-family:
    Inter,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto",
    "Oxygen",
    "Ubuntu",
    "Cantarell",
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family:
    source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

body,
html,
#root {
  --text-primary: #ade2e9;
  --bg-primary-dark: #1d2227;
  /* OVerride base bootstrap styles */
  --bs-body-font-family: "Inter", sans-serif;
  --bs-body-bg: #1d2227 !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,4CAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,4CAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,4CAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,4CAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,4CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT;;;;;;;;;;;;cAYY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;sEACoE;AACtE;;AAEA;;;EAGE,uBAAuB;EACvB,0BAA0B;EAC1B,mCAAmC;EACnC,0CAA0C;EAC1C,gCAAgC;AAClC","sourcesContent":["@font-face {\n  font-family: \"Inter\";\n  src: url(assets/fonts/Inter-Regular.ttf);\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  src: url(assets/fonts/Inter-Bold.ttf);\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: \"MyriadPro\";\n  src: url(assets/fonts/MyriadPro-reg.otf);\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"MyriadPro\";\n  src: url(assets/fonts/MyriadPro-Bold.otf);\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: \"Bai Jamjuree\";\n  src: url(assets/fonts/BaiJamjuree-Light.ttf);\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: \"Bai Jamjuree\";\n  src: url(assets/fonts/BaiJamjuree-Regular.ttf);\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Bai Jamjuree\";\n  src: url(assets/fonts/BaiJamjuree-Medium.ttf);\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: \"Bai Jamjuree\";\n  src: url(assets/fonts/BaiJamjuree-SemiBold.ttf);\n}\n\n@font-face {\n  font-family: \"Bai Jamjuree\";\n  src: url(assets/fonts/BaiJamjuree-Bold.ttf);\n  font-weight: 700;\n}\n\nbody {\n  margin: 0;\n  font-family:\n    Inter,\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    \"Roboto\",\n    \"Oxygen\",\n    \"Ubuntu\",\n    \"Cantarell\",\n    \"Fira Sans\",\n    \"Droid Sans\",\n    \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family:\n    source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\nbody,\nhtml,\n#root {\n  --text-primary: #ade2e9;\n  --bg-primary-dark: #1d2227;\n  /* OVerride base bootstrap styles */\n  --bs-body-font-family: \"Inter\", sans-serif;\n  --bs-body-bg: #1d2227 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
